import {DataWrapper} from "shared/models/data-wrapper";

export interface FileReference {
    filemime: string;
    id: string;
    label: string;
    uri: string;
}

export type FileReferenceData = DataWrapper<FileReference[]>;